import React, { useReducer, useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Row,
  Col,
  Input,
  Label,
  FormGroup,
  FormFeedback,
  CustomInput,
  Alert,
} from "reactstrap";
import LaddaButton from "react-ladda/dist/LaddaButton";
import { SLIDE_LEFT } from "react-ladda/dist/constants";
import { defaultState, Dispatch, initialize } from "./store/store";
import { orderReducer, validateForm } from "./store/reducer";
import style from "./Offer.module.scss";
import { CommissionType, Mode } from "../../../utils/Order/Order";
import { Field, Numeric } from "./Field/Field";
import Footer from "./Footer/Footer";
import { Asset, OrderInlineDetail } from "../..";
import Execution from "../Execution/Execution";
import { customFetchAssetInfo } from "./../Order/Form/commons";
import { handleFileInput, showToast, valueIsEmpty } from "../../../utils/Helper";
import { FormattedNumber } from "../../FormattedNumber/FormattedNumber";
import { Result } from "../../Asset/Calculator/Calculator";
import { commissionSuffix } from "../FundOrder/Form/commons";
import { LoadingMessage } from "../../Asset/Controls";
import { NumberFormatInput } from "../../NumberFormatInput/NumberFormatInput";
import Balance from "../Order/Field/Account/Balance";

const Offer = ({ open, toggle, fetchGetAssetInformation, ...props }) => {
  const [state, dispatch] = useReducer(orderReducer, defaultState(), initialize(props));
  const [messageResponse, setMessageResponse] = useState("");
  const [visible, setVisible] = useState(false);
  const [availableClients, setAvailableClients] = useState(0);
  const [availableAdvisors, setAvailableAdvisors] = useState(0);
  const [decimalAmount, setDecimalAmount] = useState();
  const [AssetPaymentRateFixed, setAssetPaymentRateFixed] = useState(0);
  const [assetTradesDirty, setAssetTradesDirty] = useState(null);
  const [assetName, setAssetName] = useState("");
  const [assetIsQualified, setAssetIsQualified] = useState("");
  const { ui, buttons } = state;
  const [order, setOrder] = useState(props.order);
  const [OfferCleanPrice, setOfferCleanPrice] = useState(0);
  const [OfferOriginalPrice, setOfferOriginalPrice] = useState(0);
  const postOffer = order.postOffer.postOffer;
  const update = order.update;
  const [offer, setOffer] = useState(() => {
    if (state.order.offer && state.order.offer.OfferId != undefined) {
      setOfferOriginalPrice(state.order.offer.OfferOriginalPrice);
      return {
        OfferQuantitytoAdvisor: state.order.offer.OfferQuantitytoAdvisor,
        OfferQuantitytoClient: state.order.offer.OfferQuantitytoClient,
        OfferPrice: state.order.offer.OfferOriginalPrice,
        OfferOfferQuantityTakenByAdvisor: state.order.offer.OfferOfferQuantityTakenByAdvisor,
        OfferQuantityTakenByClient: state.order.offer.OfferQuantityTakenByClient,
        OfferCleanPrice: state.order.offer.OfferCleanPrice,
        OfferOriginalPrice: state.order.offer.OfferOriginalPrice,
        OfferId: state.order.offer.OfferId,
        featured: state.order.offer.featured,
        AssetId: state.order.offer.AssetId,
        OfferDate: state.order.offer.OfferDate,
        sellingPower: state.order.sellingPower,
        balanceType: state.order.balanceType,
        bookType: state.order.bookType,
        OfferMinimumtoClient: state.order.offer.OfferMinimumtoClient
      };
    } else {
      return {
        sellingPower: state.order.sellingPower,
        balanceType: state.order.balanceType,
        bookType: state.order.bookType,
        OfferQuantitytoAdvisor: 0,
        OfferQuantitytoClient: 0,
        OfferPrice: state.order.CurrentPrice,
        OfferQuantityTakenByClient: 0,
        OfferOfferQuantityTakenByAdvisor: 0,
        OfferOriginalPrice: state.order.CurrentPrice,
        OfferCleanPrice: 0,
        OfferId: 0,
        featured: false,
        AssetId: state.order.AssetId,
        //set today date
        OfferDate: new Date().toISOString().slice(0, 10),
        OfferMinimumtoClient: 0,
      };
    }
  });

  const minimum_to_clients =
  window.___APP_CONFIG___ && window.___APP_CONFIG___.OFFER_MINIMUM_TO_CLIENTS
    ? window.___APP_CONFIG___.OFFER_MINIMUM_TO_CLIENTS
    : false;

  const rates = [
    { id: 1, name: "Nom. Rate" },
    { id: 2, name: "XIRR" },
  ];
  const [rateSelected, setRateSelected] = useState(rates.find((rate) => rate.id == 1));
  const [targetValue, setTargetValue] = useState(0);
  const [newOrderPrices, setNewOrderPrices] = useState({
    data: {
      principal: 0,
      accrual: 0,
      ytm: 0,
      TNA: 0,
      currentyield: 0,
      total: 0,
      duration: 0,
      days: 0,
      nominal: 0,
      events: [],
    },
    loading: false,
    error: null,
  });

  useEffect(() => {

    if (ui.quoteId) {
      customFetchAssetInfo(
        dispatch,
        { assetInfo: props.onOrderAssetInfo },
        {
          OrderInitDate: order.OrderInitDate,
          OrderFutureSettlmentDate: order.OrderFutureSettlmentDate,
          AssetClassForm: order.AssetClassForm,
          AssetId: order.AssetId,
          AssetTicker: order.AssetTicker,
          OrderCurrencyId: order.OrderCurrencyId,
          OrderSettlementCurrencyId: order.OrderSettlementCurrencyId,
        }
      );
    }
    if (order.OrderId != 0) {
      setAvailableAdvisors(offer.OfferQuantitytoAdvisor - offer.OfferOfferQuantityTakenByAdvisor);
      setAvailableClients(offer.OfferQuantitytoClient - offer.OfferQuantityTakenByClient);
      setOffer({
        ...offer,
        featured: offer.featured,
      });
      fetchGetAssetInformation({ assetId: order.assetId }).then((response) => {
        setDecimalAmount(response.info.SubAssetClassDecimalPlaces);
        setAssetPaymentRateFixed(response.info.AssetPaymentRateFixed);
        setAssetTradesDirty(response.info.AssetPricesDirty);
        setAssetName(response.info.AssetName);
        setAssetIsQualified(response.info.AssetIsQualified);
      });
    }
  }, [
    order.OrderInitDate,
    order.OrderFutureSettlmentDate,
    order.AssetClassForm,
    order.AssetId,
    order.AssetTicker,
    order.AdvisorQuantity,
    order.ClientQuantity,
    order.OrderCurrencyId,
    order.OrderSettlementCurrencyId,
    props.onOrderAssetInfo,
    ui.quoteId,
  ]);

  useEffect(() => {

    if (assetTradesDirty == null)
      return;

    let offerToSend = {
      ...offer,
      AssetId: order.assetId,
      OfferCleanPrice: targetValue > 0 && targetValue == AssetPaymentRateFixed ? 100 : OfferCleanPrice,
      OfferOriginalPrice: OfferOriginalPrice ? OfferOriginalPrice : offer.OfferPrice,
    };

    const calculatorRequest = {
      assetId: order.assetId,
      quantity: order.OrderQuantity,
      date: offer.OfferDate,
      price: offer.OfferPrice,
      priceisclean: !assetTradesDirty,
      priceisdirty: assetTradesDirty,
      ytm: true,
    };

    Promise.all([
      props.fetchPricesForOffer({ sdtOffer: offerToSend }),
      props.fetchGetCalculator(calculatorRequest),
    ]).then(([response1, response2]) => {
      if (response1.response.sdtOffer) {
        setOfferCleanPrice(response1.response.sdtOffer.OfferCleanPrice);
        offer.OfferId == 0 ? setOfferOriginalPrice(response1.response.sdtOffer.OfferPrice) : "";
      }
      if (response2.calculator) {
        setNewOrderPrices((prevState) => ({
          ...prevState,
          data: {
            ...response2.calculator,
            nominal: response2.calculator.assetParValue * order.OrderQuantity,
          },
        }));
        setTargetValue(rateSelected.id == 1 ? response2.calculator.TNA : response2.calculator.ytm);

      }
    });
  }, [offer.OfferPrice, assetTradesDirty]);

  const handleNewValueTNA = () => {
    if (targetValue == AssetPaymentRateFixed) {
      getPricesWhenTnaEqualsCoupon();
      return;
    }

    if (targetValue == newOrderPrices.data.TNA) return;

    const request = {
      assetId: order.assetId,
      quantity: order.OrderQuantity,
      targetValueTNA: targetValue,
      date: new Date().toISOString().slice(0, 10),
      isTargetTNA: rateSelected.id == 1,
    };

    setNewOrderPrices((prevState) => ({ ...prevState, loading: true }));

    props.fetchCalculatorDataForOffers(request).then(({ calculator_out, goalSeekResponse }) => {
      if (goalSeekResponse.Code !== 200) {
        setNewOrderPrices((prevState) => ({ ...prevState, error: true, loading: false }));
        return;
      }

      setQuantity({ OfferPrice: assetTradesDirty ? calculator_out.dirtyprice : calculator_out.cleanprice });
      setNewOrderPrices((prevState) => ({
        ...prevState,
        loading: false,
        error: false,
      }));
    });
  };

  const handleChangeRate = (rateId) => {
    const rateSelected = rates.find((rate) => rate.id == rateId);
    setRateSelected(rateSelected);
    setTargetValue(rateSelected.id == 1 ? newOrderPrices.data.TNA : newOrderPrices.data.ytm);
  };

  const getPricesWhenTnaEqualsCoupon = () => {
    const calculatorRequest = {
      assetId: order.assetId,
      quantity: order.OrderQuantity,
      date: new Date().toISOString().slice(0, 10),
      price: 100,
      priceisclean: true,
      priceisdirty: false,
      ytm: true,
    };

    if (!assetTradesDirty) {
      setQuantity({ OfferPrice: 100 });
    } else {
      setNewOrderPrices((prevState) => ({ ...prevState, loading: true }));

      props.fetchGetCalculator(calculatorRequest).then((response) => {
        if (response.result.Code != 200) {
          setNewOrderPrices((prevState) => ({ ...prevState, error: true, loading: false }));
          return;
        }

        setQuantity({ OfferPrice: response.calculator.dirtyprice });
        setNewOrderPrices((prevState) => ({
          ...prevState,
          loading: false,
          error: false,
        }));
      });
    }
  };

  const confirm = async () => {
    validateOffer();
    if (state.validOffer) {
      dispatch({
        type: "CHANGE_BUTTON_PROPS",
        props: { confirm: { loading: true } },
      });
      const { ui, precheck } = state;
      let hasErrors = false;
      let offerToSend = {
        OfferQuantitytoAdvisor: offer.OfferQuantitytoAdvisor,
        OfferQuantitytoClient: offer.OfferQuantitytoClient,
        OfferPrice: offer.OfferPrice,
        featured: offer.featured,
        AssetId: offer.AssetId,
        NominalRate: newOrderPrices.data.TNA,
        XIRR: newOrderPrices.data.ytm,
        booktype: offer.bookType,
        balancetype: offer.balanceType,
        OfferMinimumtoClient: offer.OfferMinimumtoClient
      };
      offer.OfferId == undefined ? "" : (offerToSend.OfferId = offer.OfferId);
      // check if any authorizations has error
      const authorizations = precheck.authorizations.map((auth) => {
        if (auth.text == null || !auth.text.length) {
          hasErrors = true;
          return { ...auth, error: "Required field", readonly: undefined };
        }

        return { ...auth, error: null, readonly: undefined };
      });
      offerToSend.AssetId == undefined ? (offerToSend.AssetId = order.assetId) : "";
      postOffer({
        offer: offerToSend,
        accountId: order.AccountId,
        k2btrnmode: "UPD",
      })
        .then((response) => {
          if (response.response.result.Code == 200) {
            update();
            toggle();
            showToast("success: Offer saved successfully");
          } else {
            dispatch({
              type: "CHANGE_BUTTON_PROPS",
              props: { confirm: { loading: false } },
            });
            showToast(response.response.result.Description, true);
          }
        })
        .catch((error) => {
          dispatch({
            type: "CHANGE_BUTTON_PROPS",
            props: { confirm: { loading: false } },
          });
          showToast(error.response.result.Description, true);
        });
    }
  };

  const setQuantity = (value) => {
    if (value.AdvisorQuantity != undefined) {
      setOffer({
        ...offer,
        OfferQuantitytoAdvisor: value.AdvisorQuantity,
      });
    } else if (value.ClientQuantity != undefined) {
      setOffer({
        ...offer,
        OfferQuantitytoClient: value.ClientQuantity,
      });
    } else if (value.ClientMinimum != undefined) {
      setOffer({
        ...offer,
        OfferMinimumtoClient: value.ClientMinimum,
      });
    } else {
      setOfferOriginalPrice(value.OfferPrice);
      setOffer({
        ...offer,
        OfferPrice: value.OfferPrice,
        OfferDate: new Date().toISOString().slice(0, 10),
      });
    }
  };

  const updateOfferFeatued = (value) => {
    setOffer({
      ...offer,
      featured: value,
    });
  };
  const validateOffer = () => {
    if (
      parseInt(offer.OfferQuantitytoAdvisor) + parseInt(offer.OfferQuantitytoClient) >
      state.order.OrderQuantity ||
      parseInt(offer.OfferQuantitytoAdvisor) > state.order.OrderQuantity ||
      parseInt(offer.OfferQuantitytoClient) > state.order.OrderQuantity
    ) {
      setVisible(true);
      state.validOffer = false;
      setMessageResponse("the offer taken exceed the quantity offered available");
    } else if (offer.OfferPrice <= 0) {
      state.validOffer = false;
      setVisible(true);
      setMessageResponse("the offer price must be greater than 0");
    } else if (offer.OfferMinimumtoClient < 0) {
      state.validOffer = false;
      setVisible(true);
      setMessageResponse("The minimum quantity to client must be positive");
    } else if (offer.OfferMinimumtoClient > offer.OfferQuantitytoClient) {
      state.validOffer = false;
      setVisible(true);
      setMessageResponse("The minimum quantity offered to clients must be less than the quantity offered to clients");
    } else {
      state.validOffer = true;
      setVisible(false);
    }
  };

  const cstyle = (side) => {
    return {
      background: "rgba(44, 177, 90, 0.08)",
      border: "solid 1px rgba(44, 177, 90, 1)",
      marginRight: "5px",
    };
  };

  const handleChangeTargetValue = (value) => {
    setTargetValue(value)
    setNewOrderPrices(prev => ({ ...prev, error: null }));
  }

  return (
    <Dispatch.Provider
      value={{
        state,
        dispatch,
      }}
    >
      <Modal isOpen={open} size="xl" className={style.modal}>
        <ModalHeader toggle={() => toggle(order.OrderId)}>
          <span className="mx-auto">{ui.title}</span>

          {(ui.mode === Mode.PRECHECK || ui.mode === Mode.CONFIRM || ui.mode === Mode.EXECUTE) && (
            <OrderInlineDetail order={order} hideAvg />
          )}
        </ModalHeader>
        <ModalBody className={style.body}>
          {ui.mode == Mode.EXECUTE && (
            <Execution
              open
              onToggle={() => toggle(order.OrderId)}
              entities={props.entities}
              order={order}
              orderId={order.OrderId}
              services={fetchGetAssetInformation}
            />
          )}
          {
            <React.Fragment>
              <Row>
                <Col xs={12} lg={6}>
                  <Row>
                    <Col xs={12}>
                      <Field>
                        <Label>Asset</Label>
                        <Input type="text" value={assetName} disabled={true} />
                      </Field>
                    </Col>
                    <Col xs={12} lg={6}>
                      <Field>
                        <Label>Quantity</Label>
                        <Numeric
                          placeholder={"Quantity"}
                          value={order.OrderQuantity}
                          disabled={true}
                          dataTypeDecimalName="quantity"
                        />
                      </Field>
                      <Field>
                        <Label>Clean Price</Label>
                        <Numeric
                          placeholder={"Clean Price"}
                          value={OfferCleanPrice}
                          disabled={true}
                          dataTypeDecimalName="price"
                        />
                      </Field>
                      <FormGroup>
                        <Label>Price</Label>
                        <Numeric
                          placeholder={"Price"}
                          value={offer.OfferPrice == undefined ? state.order.CurrentPrice : offer.OfferPrice}
                          invalid={offer.OfferPrice == 0 && !state.validOffer}
                          onChange={(v) => setQuantity({ OfferPrice: v })}
                          decimalScale={4}
                          dataTypeDecimalName="price"
                        />
                      </FormGroup>
                    </Col>
                    <Col xs={12} lg={6}>
                      <Field>
                        <Label>Nominal</Label>
                        <Numeric
                          placeholder={"Nominal"}
                          value={newOrderPrices.data.nominal}
                          disabled={true}
                          dataTypeDecimalName="price"
                        />
                      </Field>
                      <Field>
                        <Label>Original Price</Label>
                        <Numeric
                          placeholder={"Original Price"}
                          value={OfferOriginalPrice}
                          disabled={true}
                          dataTypeDecimalName="price"
                        />
                      </Field>
                      <Field>
                        <Label>Offer Date</Label>
                        <Input
                          type="date"
                          value={offer.OfferDate}
                          disabled={true}
                          onChange={(e) => setOffer({ ...offer, OfferDate: e.target.value })}
                        />
                      </Field>
                    </Col>
                    <Col xs={12}>
                      <Field>
                        <Label>Details</Label>
                        <Balance balance={[{ key: "Selling Power", value: offer.sellingPower }]} />
                      </Field>
                    </Col>
                    <Col xs={12} className="mt-2">
                      <FormGroup>
                        <Label>Target Price From</Label>
                        <div
                          className="d-flex justify-content-between align-items-center p-2"
                          style={{ backgroundColor: "#607e8a", padding: 5 }}
                        >
                          <UncontrolledDropdown>
                            <DropdownToggle caret>
                              <i className="fa fa-pie-chart mr-2" />
                              {rateSelected.name}
                            </DropdownToggle>
                            <DropdownMenu>
                              {rates.map((rate) => (
                                <DropdownItem onClick={() => handleChangeRate(rate.id)}>
                                  <i className="fa fa-thermometer-half" /> {rate.name}
                                </DropdownItem>
                              ))}
                            </DropdownMenu>
                          </UncontrolledDropdown>
                          <Field noLabel={true} style={{ marginBottom: 0 }}>
                            <Numeric
                              value={targetValue}
                              placeholder={"Target Nominal Rate"}
                              dataTypeDecimalName={"quantity"}
                              onChange={handleChangeTargetValue}
                              {...commissionSuffix(CommissionType.PrincipalPercentage)}
                              disabled={newOrderPrices.loading}
                            />
                          </Field>
                          <LaddaButton
                            style={{ zIndex: 0, backgroundColor: "#2db159", color: "white" }}
                            className="btn"
                            loading={newOrderPrices.loading}
                            disabled={newOrderPrices.loading}
                            onClick={handleNewValueTNA}
                            data-style={SLIDE_LEFT}
                          >
                            Recalculate
                          </LaddaButton>
                        </div>
                      </FormGroup>
                      {newOrderPrices.error != null && (
                        <Alert color={newOrderPrices.error ? "danger" : "success"}>
                          <i
                            className={
                              newOrderPrices.error
                                ? "fa fa-exclamation-triangle mr-2"
                                : "fa fa-check-circle-o mr-2"
                            }
                          ></i>
                          {newOrderPrices.error ? "Value not reached" : "Value reached successfull"}
                        </Alert>
                      )}
                    </Col>
                    <Col xs={12} lg={6} className="mt-2">
                      <div className={style.column} style={cstyle()}>
                        {/* Left */}
                        <Col>
                          <FormGroup>
                            <Field label={"Offered to Advisors"}>
                              <Numeric
                                placeholder={"Quantity"}
                                value={offer == undefined ? 0 : offer.OfferQuantitytoAdvisor}
                                onChange={(v) => setQuantity({ AdvisorQuantity: v })}
                                dataTypeDecimalName="quantity"
                              />
                              <FormFeedback>{messageResponse}</FormFeedback>
                            </Field>
                          </FormGroup>

                          {offer.OfferId != 0 && (
                            <div>
                              <Field label={"taken by Advisors: "}>
                                {offer == undefined ? (
                                  0
                                ) : (
                                  <FormattedNumber
                                    value={offer.OfferOfferQuantityTakenByAdvisor}
                                    dataTypeDecimalName="quantity"
                                  />
                                )}
                              </Field>

                              <Field label={"Remaining: "}>
                                {offer == undefined ? (
                                  0
                                ) : (
                                  <FormattedNumber value={availableAdvisors} dataTypeDecimalName="currency" />
                                )}
                              </Field>
                            </div>
                          )}
                        </Col>
                      </div>
                    </Col>
                    <Col xs={12} lg={6} className="mt-2">
                      <div className={style.column} style={cstyle()}>
                        {/* Left */}
                        <Col>
                          <Field label={"Offered to Clients"}>
                            <Numeric
                              placeholder={"Quantity"}
                              value={offer == undefined ? 0 : offer.OfferQuantitytoClient}
                              onChange={(v) => setQuantity({ ClientQuantity: v })}
                              dataTypeDecimalName="quantity"
                            />
                          </Field>
                          {minimum_to_clients && <Field label={"Minimum to Clients"}>
                            <Numeric
                              placeholder={"Quantity"}
                              value={offer == undefined ? 0 : offer.OfferMinimumtoClient}
                              onChange={(v) => setQuantity({ ClientMinimum: v })}
                              dataTypeDecimalName="quantity"
                            />
                          </Field>}

                          {offer.OfferId != 0 && (
                            <div>
                              <Field label={"taken by Clients: "}>
                                {offer == undefined ? (
                                  0
                                ) : (
                                  <FormattedNumber
                                    value={offer.OfferQuantityTakenByClient}
                                    dataTypeDecimalName="quantity"
                                  />
                                )}
                              </Field>

                              <Field label={"Remaining: "}>
                                {offer == undefined ? (
                                  0
                                ) : (
                                  <FormattedNumber value={availableClients} dataTypeDecimalName="currency" />
                                )}
                              </Field>
                            </div>
                          )}
                        </Col>
                      </div>
                    </Col>
                  </Row>
                  <FormGroup switc className="mt-3">
                    <CustomInput
                      label="Featured"
                      id="isFeatured"
                      type="switch"
                      checked={offer.featured}
                      onChange={(e) => updateOfferFeatued(e.target.checked)}
                    />
                  </FormGroup>
                  { assetIsQualified !== "" &&
                    <FormGroup switc className="mt-3">
                    <CustomInput
                      label="Asset Is Qualified"
                      id="assetIsQualified"
                      type="checkbox"
                      disabled={true}
                      checked={assetIsQualified === "Qualified"}
                    />
                  </FormGroup>
                  }
                </Col>
                <Col xs={12} lg={6}>
                  {newOrderPrices.loading ? (
                    <LoadingMessage text={"Calculating new values..."} />
                  ) : (
                    <Result result={newOrderPrices.data} />
                  )}
                </Col>
              </Row>
            </React.Fragment>
          }
        </ModalBody>
        <ModalFooter>
          <Row>
            {visible && <Label>{messageResponse}</Label>}
            <Footer
              side={order.OrderSide}
              buttons={buttons}
              mode={ui.mode}
              wizzard={{
                enabled: state.wizzard.enabled,
                activeStep: state.wizzard.activeStep,
                nextBtn: state.wizzard.nextBtn,
              }}
              actions={{
                confirm,
                toggle: toggle,
              }}
            />
          </Row>
        </ModalFooter>
      </Modal>
    </Dispatch.Provider>
  );
};

export default Offer;
